import * as THREE from 'three'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import EventEmitter from './EventEmitter.js'
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js'
import Experience from '../Experience.js'
import {OBJLoader} from 'three/examples/jsm/loaders/OBJLoader.js'

export default class Resources extends EventEmitter
{
    constructor(sources, lazySources)
    {
        super()

        this.experience = new Experience()
        this.baseDir=this.experience.baseDir

        this.sources = sources
        this.sources.push({
            name: 'divano',
            type: 'gltfModel',
            path: 'models/'+this.experience.model+'.glb'
            // path: 'models/allen1.glb'
            // path: 'models/AUTOREVERSE5.glb'
        })
        this.items = {}
        this.toLoad = this.sources.length
        this.loaded = 0
        this.modelb=false
        
        this.lazySources = lazySources
        function UrlExists(url)
        {
            var http = new XMLHttpRequest()
            http.open('HEAD', url, false)
            http.send()
            return http.status!=404
        }
        if (this.experience.modelB){
            var secDivano = UrlExists(this.baseDir+'models/'+this.experience.model+'-B.glb');
                // See if the file exists
                if(secDivano){
                    this.modelb=true
                    this.lazySources.push({
                        tipo: 'divano',
                        name: 'divano-B',
                        type: 'gltfModel',
                        path: 'models/'+this.experience.model+'-B.glb'
                    })
                }else{
                // console.log('The file does not exist');
                }
        }
        if (this.experience.modelC){
            var secDivano = UrlExists(this.baseDir+'models/'+this.experience.model+'-C.glb');
                // See if the file exists
                if(secDivano){
                    this.modelb=true
                    this.lazySources.push({
                        tipo: 'divano',
                        name: 'divano-C',
                        type: 'gltfModel',
                        path: 'models/'+this.experience.model+'-C.glb'
                    })
                }else{
                // console.log('The file does not exist');
                }
        }





        this.lazyToLoad = this.lazySources.length
        this.lazyLoaded = 0
        this.basicLoaded = false
        this.allLoaded=false
        this.aoint = Array()
        this.lmint = Array()
        this.rough = Array()
        this.invert = Array()
        this.rgb = Array()
        this.combo = Array()

        this.setLoaders()
        this.startLoading(this.sources)
    }

    setLoaders()
    {
        this.loaders = {}
        this.loaders.gltfLoader = new GLTFLoader()
        this.loaders.textureLoader = new THREE.TextureLoader()
        this.loaders.cubeTextureLoader = new THREE.CubeTextureLoader().setPath(this.baseDir)
        //   --------------- DRACO LOADER ----------------
        this.dracoLoader = new DRACOLoader()
        this.dracoLoader.setDecoderPath(this.baseDir+'draco/')
        //   --------------- GLTF LOADER ----------------
        // const gltfLoader = new GLTFLoader(loadingManager)
        this.loaders.gltfLoader.setDRACOLoader(this.dracoLoader)
        this.loaders.objLoader = new OBJLoader()
    }

    startLoading(sources)
    {
        // Load each source
        // console.log(sources)
        for(const source of sources)
        {
        if(source.type === 'gltfModel')
            {
                this.loaders.gltfLoader.load(
                    this.baseDir+source.path,
                    (file) =>
                    {
                        this.sourceLoaded(source, file)
                    }
                )
            }
            else if(source.type === 'texture')
            {
                this.loaders.textureLoader.load(
                    this.baseDir+source.path,
                    (file) =>
                    {
                        this.sourceLoaded(source, file)
                    }
                )
                // if (source.aointensity) this.aoint[source.name]=source.aointensity
                // else this.aoint[source.name]=0
                // if (source.lmintensity) this.lmint[source.name]=source.lmintensity
                // else this.lmint[source.name]=1.5
                if (source.aointensity){
                    this.aoint[source.name]=source.aointensity
                    this.lmint[source.name]=source.lmintensity
                    this.rough[source.name]=source.roughness
                    this.invert[source.name]=source.invert
                }else if (source.comboName){
                    this.combo[source.name]= [source.colore1,source.colore2]

                }
                if (source.rgb){
                    this.rgb[source.name]=source.rgb
                    // console.log(source.rgb)
                }

            }
            else if(source.type === 'cubeTexture')
            {
                this.loaders.cubeTextureLoader.load(
                    source.path,
                    (file) =>
                    {
                        this.sourceLoaded(source, file)
                    }
                )
            }
            // else if(source.type === 'objModel')
            // {
            //     this.loaders.objLoader.load(
            //         this.baseDir+source.path,
            //         (file) =>
            //         {
            //             console.log(source)
            //             console.log(file)
            //             this.sourceLoaded(source, file)
            //         }
            //     )
            // }
        }
    }

    sourceLoaded(source, file)
    {
        // console.log('pippo')
        this.items[source.name] = file
        if(!this.basicLoaded) {
            this.loaded++
            if(this.loaded === this.toLoad)
            {
                this.trigger('ready')
                this.basicLoaded=true
                // console.log(this.items)
                this.startLoading(this.lazySources)
                // console.log(this.lazySources)
            }
        }
        else {
            this.lazyLoaded++
            if(this.lazyLoaded === this.lazyToLoad){
                this.trigger('readyLazy')
                this.allLoaded=true
                // console.log(this.items)  
                if(!this.experience.debug.active) {console.clear()}          
            }
        }
    }
}